Ext.define('SA.VectorMapModelStateObserver', {
    constructor({model, handler, scope}) {
        this.model = model;

        this.observable = new Ext.util.Observable();
        this.observable.on('change', handler, scope);

        this.initEvents();
    },

    initEvents() {
        this.model.on('change:attribute', this.fireChange, this);
        this.model.on('change:businessSearch', this.fireChange, this);
        this.model.on('change:extent', this.fireChange, this);
        this.model.on('change:filter', this.fireChange, this);
        this.model.on('change:filterVisibility', this.fireChange, this);
        this.model.on('change:geographicUnit', this.fireChange, this);
        this.model.on('change:highlightLocation', this.fireChange, this);
        this.model.on('change:infoLocation', this.fireChange, this);
        this.model.on('change:labels', this.fireChange, this);
        this.model.on('change:legend', this.fireChange, this);
        this.model.on('change:legendloading', this.fireChange, this);
        this.model.on('change:legendVisible', this.fireChange, this);
        this.model.on('change:location', this.fireChange, this);
        this.model.on('change:locationMask', this.fireChange, this);
    },

    fireChange() {
        this.observable.fireEvent('change');
    }
});